import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDownloadForOffline } from "react-icons/md";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import profile from "../../assets/images/ProfileImage.jpg";
import MedicalService from "../../Services/MedicalService";
import { QRCodeCanvas } from "qrcode.react";
import { HSdecrypt } from "../../utils/encryptPassword";
import { convertUTCDate } from "../../utils/convertionFunc";
import dayjs from "dayjs";
import PatientService from "../../Services/PatientService";
import ChronicConditionService from "../../Services/ChronicConditionService";
import EmcIcon from "../../assets/images/Emcicon.png";
import UserIcon from "../../assets/images/ProfileImage.jpg";
import DrugIcon from "../../assets/images/DrugIcon.png";
import ChronicIcon from "../../assets/images/ChronicIcon.png";
import InsuranceIcon from "../../assets/images/InsuranceIcon.png";
import MedicationsIcon from "../../assets/images/MedicationIcon.png";
import Cardbg from "../../assets/images/Cardbg.png";
import CardLogo from "../../assets/images/Cardlogo.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { AiOutlineIdcard } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";

function EmergencyCard(props) {
  const frontRef = useRef();
  const backRef = useRef();
  const [patientQrData, setPatientQrData] = useState();
  const [patDetails, setPatDetails] = useState(null);
  const [image, setImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [medications, setMedications] = useState([]);
  const [chronicConditions, setChronicConditions] = useState([]);
  const [patientAlleryData, setPatientAlleryData] = useState([]);

  useEffect(() => {
    PatientEmergencyData();
    patientMedication();
    getPatientDetails();
    PatientchronicConditions();
    PatientAllergies();
  }, [props]);

  const PatientAllergies = () => {
    let payload = { patientCode: props.selectedPatient, status: 1 };
    MedicalService.HSPatientAllergyList(payload)
      .then((result) => {
        const parsedAllergyData = JSON.parse(HSdecrypt(result.data.data));
        setPatientAlleryData(
          parsedAllergyData?.map((item) => ({
            drugAllergy: item["drugAllergy"],
          })),
        );
      })
      .catch((error) => console.error(error));
  };

  const PatientchronicConditions = () => {
    ChronicConditionService.HSPatientchronicConditions({
      patientId: props.selectedPatient,
    })
      .then((result) =>
        setChronicConditions(JSON.parse(HSdecrypt(result.data.data))),
      )
      .catch((error) => console.error(error));
  };

  const getPatientDetails = async () => {
    try {
      const response = await PatientService.HSPatientData({
        patientId: props?.selectedPatient,
      });
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const patientMedication = () => {
    MedicalService.HSPatientMedication({
      patientCode: props.selectedPatient,
      status: 1,
    })
      .then((result) => setMedications(JSON.parse(HSdecrypt(result.data.data))))
      .catch((error) => console.error(error));
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;
    if (!frontSide || !backSide) return;
    try {
      backSide.style.display = "none";
      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";
      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;
      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight,
      );
      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const PatientEmergencyData = () => {
    let patientDataV = JSON.parse(
      sessionStorage.getItem("patientData") || "null",
    );
    // MedicalService.PatientQrList({ status: 1, patientId: patientDataV?.patientId }).then((result) => {
    //   if (result?.data[0]?.healthCardUrl) {
    //     setPatientQrData("https://doctor-dev.doxzon.com/emergencyqr/" + result.data[0].healthCardUrl);
    //   }
    // });
    setPatientQrData(
      `${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${patientDataV?.patientId}`,
    );
  };

  const generateQRCard = () => {
    let patientDataV = JSON.parse(
      sessionStorage.getItem("patientData") || "null",
    );
    let payload = {
      createdBy: patientDataV?.patientId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: patientDataV?.patientId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalService.GenerateQr(payload).then(() => PatientEmergencyData());
  };

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);
  const handleCardClick = () => setIsFlipped((prev) => !prev);

  const calculateAge = (dob) => {
    const dobYear = dob?.split("/")[2];
    return dobYear ? new Date().getFullYear() - Number(dobYear) : "";
  };

  return (
    <>
      {/* ── Scoped styles (mobile-only fixes, web unchanged) ── */}
      <style>{`
        /* Fix: modal title area — download + close side by side, no overlap */
        .emc-modal-title {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 10px;
          padding-right: 2px;
        }

        .emc-dl-btn {
          width: 28px;
          height: 28px;
          background: #ddfcff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: none;
          flex-shrink: 0;
          transition: background 0.2s;
        }
        .emc-dl-btn:hover { background: #c5f7ff; }

        /* Override Ant Modal so its own close button is hidden
           (we render our own CloseOutlined inside the title) */
        .emc-modal .ant-modal-close { display: none !important; }

        /* Card scene — responsive height */
        .emc-modal-scene {
          width: 100%;
          height: clamp(210px, 52vw, 260px);
          perspective: 1200px;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
        }

        .emc-modal-inner {
          position: relative;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          transition: transform 0.7s cubic-bezier(0.4,0,0.2,1);
        }
        .emc-modal-inner.flipped { transform: rotateY(180deg); }

        .emc-modal-face {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          border-radius: 12px;
          overflow: hidden;
          border: 2px solid #e2e8f0;
          box-sizing: border-box;
        }

        /* ---- FRONT ---- */
        .emc-front-face {
          background: #fff;
          display: flex;
          flex-direction: column;
        }

        .emc-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          height: 44px;
          flex-shrink: 0;
          background-size: cover;
          background-position: center;
          border-radius: 10px 10px 0 0;
        }
        .emc-card-header p {
          font-size: clamp(11px, 3vw, 14px);
          font-weight: 600;
          color: #fff;
          margin: 0;
        }
        .emc-card-header img {
          height: clamp(22px, 5vw, 30px);
          object-fit: contain;
        }

        .emc-card-body {
          display: flex;
          flex: 1;
          padding: clamp(5px, 1.5vw, 10px);
          gap: clamp(4px, 1.5vw, 10px);
          align-items: center;
          overflow: hidden;
        }

        .emc-card-left {
          display: flex;
          gap: clamp(6px, 2vw, 14px);
          align-items: center;
          flex: 1;
          min-width: 0;
        }

        .emc-card-avatar {
          width: clamp(60px, 15vw, 88px);
          height: clamp(60px, 15vw, 88px);
          border-radius: 10px;
          border: 1.5px solid #e2e8f0;
          overflow: hidden;
          flex-shrink: 0;
          background: #f1f5f9;
        }
        .emc-card-avatar img { width: 100%; height: 100%; object-fit: cover; }

        .emc-card-info { flex: 1; min-width: 0; }
        .emc-card-info h4 {
          font-size: clamp(10px, 2.5vw, 13px);
          font-weight: 400;
          color: #5c5c5c;
          margin: 0 0 clamp(2px, 0.6vw, 5px) 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .emc-card-info h4 span { font-weight: 700; color: #333; }
        .emc-card-info h4 span.blue { color: #197ebc; }

        .emc-card-qr {
          width: clamp(60px, 15vw, 88px);
          height: clamp(60px, 15vw, 88px);
          border-radius: 8px;
          border: 1.5px solid #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: #fff;
        }

        .emc-card-footer {
          height: 38px;
          background: #002b42;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: clamp(6px, 2vw, 12px);
          border-radius: 0 0 10px 10px;
          flex-shrink: 0;
          padding: 0 8px;
        }
        .emc-emergency-badge {
          background: #ef5050;
          border-radius: 6px;
          padding: 2px 8px;
          color: #fff;
          font-size: clamp(9px, 2.3vw, 12px);
          font-weight: 600;
          white-space: nowrap;
          flex-shrink: 0;
        }
        .emc-card-footer h6 {
          font-size: clamp(9px, 2.3vw, 12px);
          font-weight: 500;
          color: #fff;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .emc-card-footer h6 span {
          font-size: clamp(10px, 2.5vw, 13px);
          font-weight: 700;
        }

        /* ---- BACK ---- */
        .emc-back-face {
          background: #002b42;
          transform: rotateY(180deg);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .emc-back-body {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: clamp(10px,3vw,24px) clamp(12px,4vw,24px);
          text-align: center;
        }
        .emc-back-body p {
          font-size: clamp(11px, 2.8vw, 14px);
          font-weight: 600;
          color: #fff;
          margin: 0 0 6px 0;
        }
        .emc-back-body a {
          font-size: clamp(10px, 2.4vw, 13px);
          font-weight: 700;
          color: #189faa;
          text-decoration: underline;
          word-break: break-all;
        }
        .emc-back-footer {
          height: 40px;
          background: #f8fafc;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: clamp(6px,2vw,10px);
          border-top: 1px solid #e2e8f0;
          border-radius: 0 0 10px 10px;
          flex-shrink: 0;
        }
        .emc-member-badge {
          background: #0aa0ac;
          color: #fff;
          font-size: clamp(10px,2.5vw,13px);
          font-weight: 600;
          border-radius: 6px;
          padding: 3px 10px;
          white-space: nowrap;
        }
        .emc-back-id {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: clamp(10px,2.5vw,13px);
          color: #333;
          white-space: nowrap;
        }
        .emc-back-id span { font-weight: 700; }

        .emc-flip-hint {
          font-size: 10px;
          color: #94a3b8;
          text-align: center;
          margin-top: 5px;
          user-select: none;
        }
      `}</style>

      {/* ── Card tile (same as before) ── */}
      <div className="border rounded-lg bg-white">
        <div className="bg-brand-lightBg">
          <div className="p-3">
            <div className="flex justify-between mb-2">
              <h1 className="text-sm font-bold text-gray-700">
                Emergency Medical Data
              </h1>
              <div className="flex gap-2 items-center">
                <img src={EmcIcon} alt="" />
                <h3
                  className="text-primaryColor text-xs font-bold cursor-pointer"
                  onClick={showModal}
                >
                  View EMC
                </h3>
              </div>
            </div>
            <hr />
            <div className="h-[300px] overflow-y-auto scrollWidth">
              <div className="flex gap-3 mt-1">
                <div className="flex gap-3 items-center">
                  <img src={process.env.REACT_APP_IMAGE_URL + patDetails?.photoName || UserIcon} alt="" className="w-14 h-14 rounded-md" />
                  <div className="space-y-1">
                    <h5 className="text-xs font-medium text-gray-500">
                      <span className="text-xs text-[#004B73] font-bold">
                        {patDetails?.salutation +
                          " " +
                          patDetails?.firstName +
                          " " +
                          patDetails?.lastName}
                      </span>
                    </h5>
                    <div className="flex gap-3 items-center">
                      <h5 className="text-xs font-semibold text-[#333333]">
                        {calculateAge(patDetails?.ageDob)}
                      </h5>
                      <div className="h-4 border-l-2 border-gray-300"></div>
                      <h5 className="text-xs font-semibold text-[#333333]">
                        {patDetails?.dob}
                      </h5>
                      <div className="h-4 border-l-2 border-gray-300"></div>
                      <h5 className="font-semibold text-sm text-[#333333]">
                        {patDetails?.bloodGroup}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="text-xs font-medium text-[#189FAA] mt-2">
                Address:{" "}
                <p className="text-xs text-black font-bold">
                  {patDetails?.address1}
                </p>
              </h5>
              <div className="border shadow-lg rounded-lg mt-3 p-2">
                {patientQrData ? (
                  <div className="flex justify-center gap-2 items-center w-[90%] m-auto">
                    <p className="text-xs font-sans font-medium text-center flex items-center gap-3">
                      Scan for patient <br /> details
                      <FaArrowRightLong className="text-primaryColor" />
                    </p>
                    <div className="inline-block group mt-1">
                      <QRCodeCanvas value={patientQrData} size={90} />
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex justify-end">
                    <button
                      className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                      onClick={() => generateQRCard()}
                    >
                      Generate QR Code
                    </button>
                  </div>
                )}
              </div>
              <div className="mt-2">
                <div>
                  <div className="flex gap-2">
                    <img src={DrugIcon} alt="" />
                    <p className="font-semibold text-xs mt-1">Drug Allergies</p>
                  </div>
                  <div
                    className={`border rounded-lg p-2 grid mt-2 ${patientAlleryData.length === 1 ? "block" : ""} grid-cols-2`}
                  >
                    {patientAlleryData?.map((item, idx) => (
                      <p
                        key={idx}
                        className="text-xs font-medium font-sans text-[#333333]"
                      >
                        {item.drugAllergy}
                      </p>
                    ))}
                  </div>
                </div>
                <hr className="mt-2" />
                <div>
                  <div className="flex gap-2 mt-2">
                    <img src={ChronicIcon} alt="" />
                    <p className="font-semibold text-xs mt-1">
                      Chronic Conditions
                    </p>
                  </div>
                  <div
                    className={`border rounded-lg p-2 grid mt-2 ${chronicConditions.length === 1 ? "block" : ""} grid-cols-2`}
                  >
                    {chronicConditions?.map((item, idx) => (
                      <div key={idx}>
                        <p className="text-xs font-medium text-[#333333] truncate">
                          {item.chronicDescription}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                <hr className="mt-2" />
                <div className="mt-2">
                  <div className="flex gap-2">
                    <img src={InsuranceIcon} alt="" />
                    <p className="font-semibold text-xs">Insurance Number</p>
                  </div>
                  <p className="font-semibold text-xs font-sans ml-5 text-[#EEB205]">
                    {patDetails?.insurance}
                  </p>
                </div>
                <hr className="mt-2" />
                <div className="mt-2">
                  <div className="flex gap-2">
                    <img src={MedicationsIcon} alt="" />
                    <p className="font-semibold text-xs mt-1">
                      Current Medications
                    </p>
                  </div>
                  <div className="overflow-x-auto scrollwidth mt-2">
                    <div className="grid grid-cols-1 gap-2">
                      {medications?.map((row, index) => (
                        <div
                          key={index}
                          className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                        >
                          <div className="flex justify-between text-[#333333] text-xs">
                            <h3 className="font-bold">{row.drugName}</h3>
                            <p className="font-medium">{row.dosage}</p>
                            <p className="font-medium">
                              {row.frequency || row.dosageInstructions}
                            </p>
                          </div>
                          <div className="flex gap-2 items-center">
                            <h6 className="text-xs font-medium">
                              On set Date:
                            </h6>
                            <h6 className="border rounded-md text-[10px] p-1">
                              {row.startCreatedTime?.slice(0, 11) ||
                                dayjs(row.givenDate).format("YYYY-MM-DD")}
                            </h6>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Modal with fixed header (no overlap) ── */}
      <Modal
        className="emc-modal"
        title={
          <div className="emc-modal-title">
            {/* Download button — left of close */}
            <button
              className="emc-dl-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleDownload();
              }}
              title="Download PDF"
            >
              <FiDownload style={{ color: "#189FAA", width: 16, height: 16 }} />
            </button>
            {/* Close button — rightmost */}
            <CloseOutlined
              style={{ color: "#fff", fontSize: 14, cursor: "pointer" }}
              onClick={handleCancel}
            />
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="min(500px, 95vw)" /* ← never wider than viewport on mobile */
        footer={null}
        styles={{ body: { padding: "12px" } }}
      >
        {/* Flip card */}
        <div className="emc-modal-scene" onClick={handleCardClick}>
          <div className={`emc-modal-inner${isFlipped ? " flipped" : ""}`}>
            {/* FRONT */}
            <div className="emc-modal-face emc-front-face" ref={frontRef}>
              <div
                className="emc-card-header"
                style={{ backgroundImage: `url(${Cardbg})` }}
              >
                <p>Emergency Medical Card</p>
                <img src={CardLogo} alt="" />
              </div>

              <div className="emc-card-body">
                <div className="emc-card-left">
                  <div className="emc-card-avatar">
                    <img
                      src={
                        patDetails?.photoNameBase64
                          ? "data:image/jpeg;base64," +
                            patDetails.photoNameBase64
                          : profile
                      }
                      alt=""
                    />
                  </div>
                  <div className="emc-card-info">
                    <h4>
                      Name:{" "}
                      <span className="blue">
                        {[
                          patDetails?.salutation,
                          patDetails?.firstName,
                          patDetails?.lastName,
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      </span>
                    </h4>
                    <h4>
                      Age: <span>{calculateAge(patDetails?.ageDob)}</span>
                    </h4>
                    <h4>
                      BloodGroup: <span>{patDetails?.bloodGroup}</span>
                    </h4>
                    <h4>
                      Mobile No: <span>{patDetails?.mobile}</span>
                    </h4>
                  </div>
                </div>
                <div className="emc-card-qr">
                  {patientQrData && (
                    <QRCodeCanvas value={patientQrData} size={56} />
                  )}
                </div>
              </div>

              <div className="emc-card-footer">
                <span className="emc-emergency-badge">Emergency</span>
                <h6>
                  Mobile Number: <span>{patDetails?.emergencyContact}</span>
                </h6>
              </div>
            </div>

            {/* BACK */}
            <div className="emc-modal-face emc-back-face" ref={backRef}>
              <div className="emc-back-body">
                <p>Access my personal Health Records At:</p>
                <a
                  href={`${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${patDetails?.patientId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {`${process.env.REACT_APP_FRONTEND_URL?.replace(/^https?:\/\//, "")}/PHR-ACCESS`}
                </a>
              </div>
              <div className="emc-back-footer">
                <span className="emc-member-badge">Member ID</span>
                <div className="emc-back-id">
                  <AiOutlineIdcard style={{ width: 18, height: 18 }} />
                  <span style={{ fontWeight: 400 }}>ID No:</span>
                  <span>{patDetails?.patientId}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="emc-flip-hint">Tap card to flip</p>
      </Modal>
    </>
  );
}

export default EmergencyCard;
